import React, { useRef, useState } from 'react';
import { Upload, Loader2 } from 'lucide-react';
import {
  UploadDropZone,
  UploadIcon,
  UploadText,
  BrowseButton,
  SupportedFormats,
} from '../uploadDocuments.styles';

const DropZone = ({ onFilesSelect, isUploading, accept = '.pdf' }) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFileChange = (e) => {
    if (e.target.files?.length) {
      onFilesSelect(e.target.files);
      e.target.value = '';
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    if (e.dataTransfer.files?.length) onFilesSelect(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleBrowse = () => fileInputRef.current?.click();

  return (
    <UploadDropZone
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      $isDragging={isDragging}
      $isUploading={isUploading}
    >
      <UploadIcon $isUploading={isUploading}>
        {isUploading ? (
          <Loader2 size={48} strokeWidth={1.5} className="spin" />
        ) : (
          <Upload size={48} strokeWidth={1.5} />
        )}
      </UploadIcon>

      {isUploading ? (
        <UploadText>Uploading files…</UploadText>
      ) : (
        <>
          <UploadText>Drag and drop files here</UploadText>
          <span style={{ color: 'var(--color-text-tertiary)', fontSize: '13px' }}>or</span>
          <BrowseButton onClick={handleBrowse} disabled={isUploading} type="button">
            Browse Files
          </BrowseButton>
          <SupportedFormats>Supports PDF &bull; Max 50MB per file</SupportedFormats>
        </>
      )}

      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        multiple
        onChange={handleFileChange}
        style={{ display: 'none' }}
        aria-hidden="true"
      />
    </UploadDropZone>
  );
};

export default DropZone;
